import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form, Button, Input, message } from "antd";
import { API, history, imgRoot } from "../../static/js/common";
import { withRouter } from 'react-router-dom';
import { MobileOutlined, LockOutlined ,UserOutlined} from '@ant-design/icons';

const FormItem = Form.Item;
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPwdLogin: true,
      is_send: false,
      getcode: "获取验证码",
      phone: "",
    };
  }

  componentDidMount() {
  }

  waitingVefiry = () => {
    // 获取验证码倒计时
    let countdown = 60;
    if (this.state.is_send) return;
    clearInterval(window._verify_timer);
    window._verify_timer = null;
    this.setState({
      is_send: true,
      getcode: `${countdown}s后重新获取`,
    });
    window._verify_timer = setInterval(() => {
      countdown--;
      let tips = `${countdown}s后重新获取`,
        send = true;
      if (countdown === 0) {
        clearInterval(window._verify_timer);
        tips = "获取验证码";
        send = false;
      }
      this.setState({ getcode: tips, is_send: send });
    }, 1000);
  };

  getVerifyCode = () => {
    // 获取验证码
    const { phone, is_send } = this.state;
    if (is_send) return;
    const mobile = phone.replace(/\s/g, "");
    if (
      !/^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(
        mobile
      )
    ) {
      message.error("手机号码输入有误！", 1.2);
      return;
    }
    API.getSmsCode({
      mobile,
      // sendType: "userRegister",
    }).then((res) => {
      if (res.status * 1 === 0) {
        message.success("发送成功", 1.2);
        this.waitingVefiry();
      } else {
        message.error(res.message || "验证码发送失败！", 1.2);
        this.setState({
          is_send: false,
        });
      }
    });
  };

  onSubmit = (values) => {
    const { isPwdLogin } = this.state;
    const fr  = window.localStorage.getItem("from-origin");
    const inviteCode  = window.localStorage.getItem("invite-code");
    const { mobile, password, verifyCode } = values;
    if (
      !/^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(
        mobile
      )
    ) {
      message.error("请输入正确的手机号");
      return;
    }
    if (isPwdLogin) {
      const params = { mobile, password, channel: 2 , fr}
      if(inviteCode) {
        params.inviteCode = inviteCode
      }
      API.postLogin(params).then((res) => {
        if (res.status * 1 === 0) {
          
          this.props.history.push("/?tabKey=all");
          window.localStorage.setItem("dfToken", res.extData.token);
          window.location.reload();
        } else {
          message.error(res.message || "登录错误");
        }
      });
    } else {
      const params = { mobile, captcha: verifyCode, channel: 2, fr}
      if(inviteCode) {
        params.inviteCode = inviteCode
      }
        API.postCaptchaLogin(params).then((res) => {
        if (res.status * 1 === 0) {
          this.props.history.push("/?tabKey=all");
          window.localStorage.setItem("dfToken", res.extData.token);
          window.location.reload();
        } else {
          message.error(res.message || "登录错误");
        }
      });
    }
  };

  render() {
    const { isPwdLogin, getcode } = this.state;
    const prefix_login = (
      <div className="prefix">
        {/* <img alt="" src={`${imgRoot}/username.png`} /> */}
        {/* <MobileOutlined style={{ fontSize: 24,marginTop: 8  }} /> */}
        <UserOutlined style={{ fontSize: 24,marginTop: 8  }}></UserOutlined>
      </div>
    );
    const prefix_pwd = (
      <div className="prefix">
        <LockOutlined style={{ fontSize: 24,marginTop: 8 }} />
        {/* <img alt="" src={`${imgRoot}/pwd.png`} /> */}
      </div>
    );
    return (
      <div className="login">
        <main className="login_bg">
          {/*  <img
            alt=""
            width="100%"
            style={{ zIndex: -1 }}
            src={`${imgRoot}/background.jpg`}
          /> */}
          <div className="background_color"></div>
          <div className="log_box">
            <div style={{ position: "relative" }}>
              <div className="log_content">
                <img width="660" alt="" src={`${imgRoot}/login1.png`} />
                <div className="login_box1">
                  <p className="login_text">登录</p>
                  <Form onFinish={this.onSubmit} className="login_from">
                    <FormItem
                      name="mobile"
                      rules={[
                        {
                          required: true,
                          message: "请输入手机号",
                        },
                      ]}
                    >
                      <Input
                        prefix={prefix_login}
                        placeholder="请输入手机号"
                        onChange={(e) =>
                          this.setState({ phone: e.target.value })
                        }
                      />
                    </FormItem>
                    {isPwdLogin ? (
                      <FormItem
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "请输入密码",
                          },
                        ]}
                        style={{ marginBottom: 6 }}
                      >
                        <Input.Password
                          prefix={prefix_pwd}
                          type="password"
                          placeholder="请输入密码"
                        />
                      </FormItem>
                    ) : (
                      <FormItem
                        name="verifyCode"
                        rules={[
                          {
                            required: true,
                            message: "请输入验证码",
                          },
                        ]}
                        style={{ marginBottom: 6 }}
                      >
                        <Input
                          prefix={prefix_pwd}
                          placeholder="请输入验证码"
                          addonAfter={
                            <div
                              className="get_code"
                              onClick={this.getVerifyCode}
                            >
                              {getcode}
                            </div>
                          }
                        />
                      </FormItem>
                    )}
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div
                      style={{
                        color: "#33AAFF",
                        cursor: "pointer",
                        marginTop: 12,
                        fontSize: 12
                      }}
                      onClick={() => this.setState({ isPwdLogin: !isPwdLogin })}
                    >
                      {isPwdLogin ? "短信验证码登录" : "账号密码登录"}
                    </div>
                    {
                      // !isPwdLogin && (
                        <div
                        className="flex-space"
                         style={{
                           color: "red",
                          //  cursor: "pointer",
                           marginTop: 12,
                           marginLeft:30
                         }}
                       >
                        <Link to="/register?tabKey=login">
                          <div onClick={(_) => this.setState({ tabKey: "seller" })} style={{marginRight:5,textDecoration: 'underline',fontSize: 12}}>
                              免费注册
                          </div>
                        </Link>
                        {/* 如若遇到验证码问题请联系客服 */}
                        <Link to="/forget?tabKey=login" style={{textDecoration: 'underline',fontSize: 12}}>
                          <div onClick={(_) => this.setState({ tabKey: "seller" })}>
                            找回密码
                          </div>
                        </Link>
                       </div>
                      // )
                    }
                  </div>
                    <FormItem>
                      <Button className="btn" htmlType="submit">
                        登录
                      </Button>
                    </FormItem>
                  </Form>
                  <div className="flex-space" style={{ display: 'flex',justifyContent: 'center', alignItems: 'center',marginTop:-10}}>
                    <span style={{fontSize: 12,color:'#33aaff', display: 'inline-block'}}>欢迎使用小狼礼品</span>
                    {/* <Link to="/register?tabKey=login"> */}
                      {/* <div onClick={(_) => this.setState({ tabKey: "seller" })} style={{display: 'none'}}> */}
                    {/* </Link> */}
                  </div>
                  {/* <Link to="/register?tabKey=login">
                    <div onClick={(_) => this.setState({ tabKey: "seller" })} style={{display: 'flex',justifyContent: 'center', alignItems: 'center',textDecoration: 'underline',fontSize: 12}}>
                        免费注册
                    </div>
                  </Link> */}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}
export default withRouter(Login);
